import * as React from 'react'
import { LabelListConnected } from './LabelListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const LabelListExamples = () => {
  return (
    <div className="LabelListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <LabelListConnected />
      </Provider>
    </div>
  )
}
